import httpClient from "./httpClient";

const ReadinessLevelService = {
  async findAll() {
    return await httpClient.get("/readiness-level");
  },
};

export default ReadinessLevelService;
